export default "__VITE_ASSET__CWTj6hVy__"